/**
 * Phone sanitisation.
 *
 * Client logins are derived from the party/lead phone number (`client_<phone>`),
 * and the login form rejects whitespace — so a number saved as "90420 45501"
 * produces a login id nobody can actually type. Strip every whitespace character
 * (including the non-breaking and zero-width ones that ride along with a paste
 * from WhatsApp or Excel) before the value leaves the form.
 *
 * Only whitespace is removed: separators like `+` or `-` are left alone so
 * existing numbers keep whatever formatting they were entered with.
 */
const WHITESPACE = /[\s\u200b-\u200d\u2060]/g;

export function sanitizePhone(value: string): string;
export function sanitizePhone(value: string | undefined): string | undefined;
export function sanitizePhone(value: string | null): string | null;
export function sanitizePhone(
  value: string | null | undefined,
): string | null | undefined;
export function sanitizePhone(value: string | null | undefined) {
  if (value == null) return value;
  return value.replace(WHITESPACE, "");
}
